import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ShieldAlert, Check } from "lucide-react";

export default function McpAlertsPanel({ onChanged }) {
    const [items, setItems] = useState(null);
    const load = useCallback(async () => {
        try { setItems((await api.get("/admin/mongo-mcp/alerts")).data.items || []); }
        catch (e) { toast.error(formatApiErrorDetail(e)); }
    }, []);
    useEffect(() => { load(); }, [load]);
    const ack = async (id) => {
        try { await api.post(`/admin/mongo-mcp/alerts/${id}/ack`); await load(); onChanged?.(); window.dispatchEvent(new Event("mongo-alerts-changed")); }
        catch (e) { toast.error(formatApiErrorDetail(e)); }
    };
    return (
        <div id="alerts" className="bg-[#0a0a0a] border border-white/10 rounded-md" data-testid="mcp-alerts-card">
            <div className="flex items-center gap-2 px-5 py-4 border-b border-white/10">
                <ShieldAlert className="w-4 h-4 text-red-400" strokeWidth={1.5} />
                <div className="font-display text-lg tracking-tight">Withheld results</div>
                <div className="text-[11px] text-white/45 ml-2">A find result held another company's record — nothing reached the caller.</div>
            </div>
            {items === null ? <div className="px-5 py-6 text-xs text-white/40">Loading…</div> : items.length === 0 ? (
                <div className="px-5 py-6 text-xs text-white/40" data-testid="mcp-alerts-empty">No withheld results. The company lock has held.</div>
            ) : (
                <div className="divide-y divide-white/5">
                    {items.map((a) => (
                        <div key={a.id} className="px-5 py-3 flex items-start gap-3" data-testid={`mcp-alert-${a.id}`}>
                            <span className={`mt-1 w-1.5 h-1.5 rounded-full ${a.acknowledged ? "bg-white/25" : "bg-red-500 animate-pulse"}`} />
                            <div className="flex-1 min-w-0">
                                <div className="text-xs text-white/85">{a.reason}</div>
                                <div className="text-[10px] font-mono text-white/45 mt-0.5">
                                    {new Date(a.at).toLocaleString()} · {a.tool} · {a.database}.{a.collection} · company {(a.companies || []).join(", ")} · {a.actor?.email || a.actor?.kind}
                                    {a.agent_id ? ` · agent ${a.agent_id.slice(0, 8)}` : ""}{a.chat_id ? ` · chat ${a.chat_id.slice(0, 8)}` : ""}
                                </div>
                            </div>
                            {a.acknowledged ? (
                                <span className="text-[10px] text-white/40 font-mono" data-testid={`mcp-alert-acked-${a.id}`}>acknowledged by {a.acknowledged_by}</span>
                            ) : (
                                <button onClick={() => ack(a.id)} data-testid={`mcp-alert-ack-${a.id}`}
                                    className="px-2.5 py-1 rounded text-[11px] border border-white/15 hover:bg-white/5 flex items-center gap-1 transition-colors">
                                    <Check className="w-3 h-3" /> Acknowledge
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
